import { render, staticRenderFns } from "./ProcessDefinitions.vue?vue&type=template&id=6297e68e&scoped=true&"
import script from "./ProcessDefinitions.vue?vue&type=script&lang=js&"
export * from "./ProcessDefinitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297e68e",
  null
  
)

export default component.exports